import { createContext, useContext } from 'react';

export interface ShellActions {
  openSearch: () => void;
  openNotifications: () => void;
  openWorkspaceSwitcher: () => void;
  logout: () => Promise<void>;
  switchWorkspace: (organizationId: string) => Promise<void>;
}

const ShellActionsContext = createContext<ShellActions | null>(null);

export const ShellActionsProvider = ShellActionsContext.Provider;

/** Shell-level actions for pages below the AppShell (mobile "Mehr", settings). */
export function useShellActions(): ShellActions {
  const actions = useContext(ShellActionsContext);
  if (actions === null) throw new Error('useShellActions() needs the AppShell');
  return actions;
}
